import { lazyLoad, createIcon } from "./helpers";
import { instituteRoutes, userRoutes, activityRoutes, salesTimelineRoutes, salesScheduleRoutes } from "./subRoutes";

const SalesDashboard = lazyLoad("Dashboard/SalesDashboard");
const Institutes = lazyLoad("Institutes");
const Users = lazyLoad("Users");
const SalesActivities = lazyLoad("SalesActivities");
const SalesTimeline = lazyLoad("SalesTimeline");
const SalesSchedules = lazyLoad("SalesSchedules");
const SalesCalendar = lazyLoad("Calendar");
const SalesCalendarList = lazyLoad("Calendar/SalesCalendarList");

export const salesadminMainRoutes = [
  {
    path: "SalesDashboard",
    label: "Dashboard",
    element: <SalesDashboard />,
    icon: createIcon("home"),    
    module: ["sales"],
  },
  {
    path: "Institutes",
    element: <Institutes />,
    icon: createIcon("institute"),    
    children: instituteRoutes,
    module: ["sales"],
  },
  {
    path: "Users",
    element: <Users />,
    icon: createIcon("user"),    
    children: userRoutes,
    module: ["sales"],
  },
  {
    path: "SalesActivities",
    label: "Sales Activities",
    element: <SalesActivities />,
    icon: createIcon("user"),
    children: activityRoutes,
    module: ["sales"],
  },
  {
    path: "Timeline",
    label: "Sales Timeline",
    element: <SalesTimeline />,
    icon: createIcon("sales_timeline"),    
    children: salesTimelineRoutes,
    module: ["sales"],
  },
  {
    path: "SalesSchedules",
    label: "Sales Schedules",
    element: <SalesSchedules />,
    icon: createIcon("training"),    
    children: salesScheduleRoutes,
    module: ["sales"],
  },
  {
    path: "SalesCalendar",
    label: "Sales Calendar",
    element: <SalesCalendar />,
    icon: createIcon("calender"),
    children: [{ path: "", element: <SalesCalendarList /> }],
    module: ["sales"],
  },
];

export const salespersonMainRoutes = [
  {
    path: "Dashboard",
    label: "Dashboard",
    element: <SalesDashboard />,
    icon: createIcon("home"),    
    module: ["sales"],
  },
  {
    path: "Institutes",
    element: <Institutes />,
    icon: createIcon("institute"),    
    children: instituteRoutes,
    module: ["sales"],
  },
  {
    path: "SalesActivities",
    label: "Sales Activities",
    element: <SalesActivities />,
    icon: createIcon("user"),    
    children: activityRoutes,
    module: ["sales"],
  },
  {
    path: "Timeline",
    label: "Sales Timeline",
    element: <SalesTimeline />,
    icon: createIcon("sales_timeline"),    
    children: salesTimelineRoutes,
    module: ["sales"],
  },
  {
    path: "SalesSchedules",
    label: "Sales Schedules",
    element: <SalesSchedules />,
    icon: createIcon("training"),    
    children: salesScheduleRoutes,
    module: ["sales"],
  },
  {
    path: "SalesCalendar",
    label: "Sales Calendar",
    element: <SalesCalendar />,
    icon: createIcon("calender"),
    children: [{ path: "", element: <SalesCalendarList /> }],
    module: ["sales"],
  },
];
